import { type ExtensionConfig, PrerequisiteRuleTypes } from '@goto/shell-common'
import { getFeatureFlag } from '../helpers/shell-helpers'

const extensionConfig: ExtensionConfig = {
  id: '@goto/notifications',
  esModule: true,
  get url() {
    const version = getFeatureFlag('shell-extensions-notifications-version', 'latest')
    return new URL(`experiences/shell-extensions/${version}/notifications/index.js`, location.origin)
  },
  prerequisites: { [PrerequisiteRuleTypes.SHELL_FEATURE_FLAGS]: 'shell-unified-notifications-settings' },
}

export default extensionConfig
